import { Helmet } from "react-helmet-async";
import MainLayout from "../app/layouts/MainLayout";
import {
  Contact,
  FAQ,
  Hero,
  Pricing,
  Process,
  Services,
  Strengths,
  Works,
} from "../components/top";
import { topNavLinks } from "../components/top/navLinks";
import { useSectionReveal } from "../shared/hooks/useSectionReveal";

function Top() {
  useSectionReveal();

  return (
    <>
      <Helmet>
        <title>cocoIT（ココイト）- アプリ開発・Web制作・保守運用</title>
        <meta
          name="description"
          content="cocoITは、アプリ開発、Webサイト制作、保守運用を提供します。要件定義から運用まで一貫対応。レスポンシブ対応、SEO最適化、セキュリティ配慮で高品質なソリューションを提供します。"
        />
        <meta
          name="keywords"
          content="アプリ開発,Web制作,保守運用,IT開発,レスポンシブ,SEO"
        />
        <link rel="canonical" href="https://cocoit.jp/" />
        <meta
          property="og:title"
          content="cocoIT - アプリ開発・Web制作・保守運用"
        />
        <meta
          property="og:description"
          content="要件定義から運用まで一貫対応するプロフェッショナルIT開発サービス"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://cocoit.jp/" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="cocoIT - アプリ開発・Web制作・保守運用"
        />
        <meta
          name="twitter:description"
          content="要件定義から運用まで一貫対応するプロフェッショナルIT開発サービス"
        />
      </Helmet>
      <MainLayout navLinks={topNavLinks}>
        <Hero />
        <Services />
        <Strengths />
        <Process />
        <Works />
        <Pricing />
        <FAQ />
        <Contact />
      </MainLayout>
    </>
  );
}

export default Top;
